module.exports = __webpack_public_path__ + "static/media/lp-graphic.38839617.jpeg";